import { actionTypes } from "./express-notifications.actions";

export interface IExpressNotificationListItem {
    userId: string;
    imageUrl: string;
    petName: string;
};

export interface IExpressNoticationListState {
    expressNotificationsList: IExpressNotificationListItem[];
};

const initialState : IExpressNoticationListState = {
  expressNotificationsList: [],
};

export const expressNotificationListReducer = (
  state: IExpressNoticationListState = initialState,
  action: { type: string, payload: any },
)=>{
  switch (action.type) {
  case actionTypes.APPEND_EXPRESS_NOTIFICATION_LIST:
    return {
      ...state,
      expressNotificationsList: [
        ...state.expressNotificationsList,
        ...action.payload,
      ],
    };
  case actionTypes.SET_EXPRESS_NOTIFICATION_LIST:
    return {
      ...state,
      expressNotificationsList: action.payload,
    };
  default: {
    return state;
  }
  }
};
